import {createFeature, createReducer, createSelector, on} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter, Dictionary} from '@ngrx/entity';
import {LocationModel} from "../../../models/location.model";
import {Update} from "@ngrx/entity";
import {LocationActions, LocationsAPiActions, LocationsChannelActions} from "./locations.actions";
import {Service} from "../../../../deliveries/models/service.model";

export interface LocationsState extends EntityState<LocationModel> {
}

const adapter: EntityAdapter<LocationModel> = createEntityAdapter<LocationModel>({
  selectId: (location: LocationModel) => location.holderId
});

const initialState: LocationsState = adapter.getInitialState();

const reducer = createReducer(
  initialState,

  on(LocationsChannelActions.notificationReceived, (state, {notification}) => {

    if (state.entities[notification.holderId]?.updatedAt < notification.updatedAt) {
      const changes: Update<Service> = {
        id: notification.holderId,
        changes: {...notification}
      }
      return adapter.updateOne(changes, state);
    } else {
      return state;
    }

  }),

  on(LocationsAPiActions.getLocationSuccess, (state, {location}) => adapter.setOne(location, state)),

  on(LocationsAPiActions.getLocationsSuccess, (state, {locations}) => adapter.setMany(locations, state)),

  on(LocationActions.setLocations, (state, {locations}) => adapter.setMany(locations, state)),

  on(LocationActions.removeLocations, (state, {ids}) => adapter.removeMany(ids, state)),

  on(LocationActions.removeAll, (state) => adapter.removeAll(state))
);

export const locationsFeature = createFeature({
  name: 'Locations',
  reducer,
  extraSelectors: ({selectLocationsState, selectEntities}) => ({
    ...adapter.getSelectors(selectLocationsState),
    // selectLocations: () => createSelector(
    //   selectEntities,
    //   (entities: Dictionary<LocationModel>) => {
    //     return Object.values(entities || {})
    //   },
    // ),
    selectLocation: (id: string) => createSelector(
      selectEntities,
      (entities: Dictionary<LocationModel>) => entities ? entities[id] : undefined,
    )
  })
});
